// src/pages/SellerIntelligence/Sales/SalesHub.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiCalendar, FiArrowLeft, FiBarChart2, FiActivity, FiMapPin } from 'react-icons/fi';
import styles from '../SellerIntelligence.module.css';
import FeatureCardGrid from '../components/FeatureCardGrid';

// Index of the Sales domain.
const DASHBOARDS = [
  {
    id: 'sales_performance',
    title: 'Sales Performance Dashboard',
    description: 'Sales and units over time with returns plotted against them, plus the products, brands and categories driving the numbers.',
    icon: <FiBarChart2 />,
    route: '/dashboard/seller-intelligence/sales/sales-performance',
    action: 'Open →'
  },
  {
    id: 'product_performance',
    title: 'Product Performance Deep Dive',
    description: 'The behaviour underneath the revenue: sessions, conversion, how fast each product moves and how long stock lasts.',
    icon: <FiActivity />,
    route: '/dashboard/seller-intelligence/sales/product-performance',
    action: 'Open →'
  },
  {
    id: 'geographic_sales',
    title: 'Geographic Sales Intelligence',
    description: 'Which states, cities and pincodes drive revenue, and which products sell differently by region.',
    icon: <FiMapPin />,
    route: '/dashboard/seller-intelligence/sales/geographic',
    action: 'Open →'
  },
  {
    id: 'seasonal',
    title: 'Seasonal Performance Analyser',
    description: 'What your sales year looks like once growth and festival spikes are taken out, so a strong month reads as a real pattern rather than a good year.',
    icon: <FiCalendar />,
    route: '/dashboard/seller-intelligence/sales/seasonal',
    action: 'Open →'
  }
];

const SalesHub = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.featureContainer}>
      <div className={styles.header}>
        <button
          className={styles.backButton}
          onClick={() => navigate('/dashboard/seller-intelligence')}
        >
          <FiArrowLeft /> Back
        </button>
        <div className={styles.titleSection}>
          <div className={styles.iconTitle}><h1>Sales</h1></div>
          <p>How the business is moving, over any period, without exporting anything</p>
        </div>
      </div>
      <div className={styles.content}>
        <FeatureCardGrid items={DASHBOARDS} />
      </div>
    </div>
  );
};

export default SalesHub;
